import script from "./BulkUserUploadBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkUserUploadBox.vue?vue&type=script&setup=true&lang=js"

import "./BulkUserUploadBox.vue?vue&type=style&index=0&id=ae2e0944&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae2e0944"]])

export default __exports__